import { render, staticRenderFns } from "./MobileKline.vue?vue&type=template&id=5045c0da&scoped=true"
import script from "./MobileKline.vue?vue&type=script&lang=js"
export * from "./MobileKline.vue?vue&type=script&lang=js"
import style0 from "./MobileKline.vue?vue&type=style&index=0&id=5045c0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5045c0da",
  null
  
)

export default component.exports